import * as React from "react";
import { cardImages } from "./CardComponent";

interface ILoadingComponentProps {
    onLoad: Function;
}

interface ILoadingComponentState {
    total: number;
    loaded: number;
}

export class LoadingComponent extends React.Component<ILoadingComponentProps, ILoadingComponentState> {
    images: HTMLImageElement[] = [];

    componentWillMount() {
        const total = Object.keys(cardImages).length;
        let loaded: number = 0;

        for (let id in cardImages) {
            const img = new Image(cardImages[id]);
            img.onload = () => {
                loaded++;
                this.setState({ loaded });

                if (loaded === total) {
                    this.props.onLoad();
                }
            };
            img.src = cardImages[id];

            this.images.push(img);
        }

        this.setState({ total, loaded });
    }

    componentWillUnmount() {
        this.images = [];
    }

    public render() {
        return (<section className="loading">
            <div className="content">
                <h1>Play Cribbage Online</h1>
                <div className="progress">
                    <div className="bar" style={{ width: ((this.state.loaded / this.state.total) * 100) + "%" }} />
                </div>
            </div>
        </section>);
    }

}


// WEBPACK FOOTER //
// ./src/components/LoadingComponent.tsx